import { useNavigate, useLocation } from 'react-router';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useMfa } from '../context/MfaContext';
import { useMfaToast } from './useMfaToast';
import { MeContext } from '../context/MeContext';
import { useMfaApi } from './useMfaApi';

export const useMfaNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useContext(AuthContext);
  const {
    completeMfaSetup,
    setMfaVerified,
    mfaMethod,
    isSettingUp,
    clearMfaSetup,
  } = useMfa();
  const { showSuccessToast, showErrorToast } = useMfaToast();
  const meCtx = useContext(MeContext);
  const { revertOtpSetup, lockAccount } = useMfaApi();

  const handleSetupSuccess = (onSuccess) => {
    completeMfaSetup();
    if (onSuccess) {
      onSuccess();
    } else if (mfaMethod === 'totp') {
      navigate('/mfa/setup/recovery-code');
    } else if (mfaMethod === 'email') {
      navigate('/dashboard', { replace: true });
      showSuccessToast(
        'MFA setup completed successfully',
        'Your account is now protected with multi-factor authentication'
      );
    }
  };

  const handleVerificationSuccess = (onSuccess) => {
    setMfaVerified(true);
    if (onSuccess) {
      onSuccess();
    } else {
      const nextPath = location?.state?.next?.pathname || '/dashboard';
      navigate(nextPath, { replace: true });
    }
  };

  const handleTooManyAttempts = async (error) => {
    showErrorToast(
      'Too many failed attempts',
      error.response?.data?.message || 'Please try again later.',
      5000
    );

    if (isSettingUp) {
      try {
        const originalMethod = meCtx?.state?.account?.otp_method;
        const originalSecret = meCtx?.state?.account?.otp_secret;
        await revertOtpSetup(originalMethod, originalSecret);
      } catch (error) {
        console.error('Error reverting OTP setup:', error);
      }
    }

    try {
      await lockAccount();
    } catch (error) {
      console.error('Error locking account:', error);
    }

    clearMfaSetup();
    logout();
    navigate('/login', { replace: true });
  };

  return {
    handleSetupSuccess,
    handleVerificationSuccess,
    handleTooManyAttempts,
  };
};
